import { render, staticRenderFns } from "./FittingsOut.vue?vue&type=template&id=b3867ca2&scoped=true"
import script from "./FittingsOut.vue?vue&type=script&lang=js"
export * from "./FittingsOut.vue?vue&type=script&lang=js"
import style0 from "./FittingsOut.vue?vue&type=style&index=0&id=b3867ca2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3867ca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3867ca2')) {
      api.createRecord('b3867ca2', component.options)
    } else {
      api.reload('b3867ca2', component.options)
    }
    module.hot.accept("./FittingsOut.vue?vue&type=template&id=b3867ca2&scoped=true", function () {
      api.rerender('b3867ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fittings/FittingsOut.vue"
export default component.exports